export let ImageResizeMode = /*#__PURE__*/function (ImageResizeMode) {
  ImageResizeMode["Crop"] = "crop";
  ImageResizeMode["Fit"] = "fit";
  return ImageResizeMode;
}({});
//# sourceMappingURL=imageResizeMode.js.map